import { render, staticRenderFns } from "./main1.vue?vue&type=template&id=968a25c4&"
import script from "./main1.vue?vue&type=script&lang=js&"
export * from "./main1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports